import React from 'react';
import { Modal, Button } from 'rsuite';
import './eaeuWarningModal.css';
import { useTranslation } from 'react-i18next';

export default function EAEUWarningModal({ open, onClose }) {
  const { t } = useTranslation('basic');
  
  return (
    <Modal 
      open={open} 
      onClose={onClose} 
      size="sm" 
      className="eaeuWarningModal"
      backdropClassName="eaeuWarningModal-backdrop"
    >
      <Modal.Header>
        <Modal.Title>{t('attention')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="paragraph-14R">
          {t('eaeu_warning_text')}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onClose} appearance="primary" color="green">
          {t('understood')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}




